module.exports = __webpack_public_path__ + "img/logo.dd854ae8.svg";